import { faCircleDollarToSlot } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import { CreateIapPollForm } from '~/components/forms/IapPollForm';
import { Heading } from '~/components/molecules/Heading';
import { useNavigate } from '~/components/utils/Navigation';
import { Breadcrumbs } from '../molecules/Breadcrumbs';
import { AppBreadcrumbs } from '../organisms/Breadcrumbs';

export type IAppCreateIapPollPageProps = {
  appId: string;
};

export const AppCreateIapPollPage: React.FC<IAppCreateIapPollPageProps> = (
  props,
) => {
  const { appId } = props;
  const { t } = useTranslation();
  const navigate = useNavigate();

  const parentUrl = `/apps/${appId}/iapPolls`;

  return (
    <>
      <Helmet>
        <title>{t('AppCreateIapPollPage.seo.title')}</title>
      </Helmet>

      <AppBreadcrumbs appId={appId}>
        <Breadcrumbs.Action href={parentUrl}>
          <FontAwesomeIcon icon={faCircleDollarToSlot} />
          {t('AppIapPollsPage.title')}
        </Breadcrumbs.Action>
      </AppBreadcrumbs>

      <Heading
        title={t('AppCreateIapPollPage.title')}
        previousUrl={parentUrl}
      />

      <CreateIapPollForm
        appId={appId}
        onSuccess={() => navigate(parentUrl)}
        cancelUrl={parentUrl}
      />
    </>
  );
};
